// Mock data for Frames by Gaurav Photography Portfolio
//mock data
export const galleries = {
  wedding: [
    {
      id: 1,
      url: 'https://images.pexels.com/photos/35501140/pexels-photo-35501140.jpeg',
      title: 'Intimate Ceremony',
      category: 'Wedding',
      tagline: 'Where two souls become one',
    },
    {
      id: 2,
      url: 'https://images.pexels.com/photos/35475949/pexels-photo-35475949.jpeg',
      title: 'First Dance',
      category: 'Wedding',
      tagline: 'Dancing through life together',
    },
    {
      id: 3,
      url: 'https://images.pexels.com/photos/35475957/pexels-photo-35475957.jpeg',
      title: 'Reception',
      category: 'Wedding',
      tagline: 'Celebrating love and laughter',
    },
    {
      id: 4,
      url: 'https://images.pexels.com/photos/35475961/pexels-photo-35475961.jpeg',
      title: 'Couple Portrait',
      category: 'Wedding',
      tagline: 'Love captured in a single frame',
    },
    {
      id: 5,
      url: 'https://images.pexels.com/photos/35475959/pexels-photo-35475959.jpeg',
      title: 'Wedding Details',
      category: 'Wedding',
      tagline: 'Every detail tells a story',
    },
    {
      id: 6,
      url: 'https://images.pexels.com/photos/35475976/pexels-photo-35475976.jpeg',
      title: 'Bridal Portrait',
      category: 'Wedding',
      tagline: 'Beauty beyond words',
    },
  ],
  events: [
    {
      id: 7,
      url: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80',
      title: 'Corporate Event',
      category: 'Events',
      tagline: 'Professional moments that matter',
    },
    {
      id: 8,
      url: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
      title: 'Conference',
      category: 'Events',
      tagline: 'Ideas that inspire change',
    },
    {
      id: 9,
      url: 'https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=800&q=80',
      title: 'Celebration',
      category: 'Events',
      tagline: 'Moments worth celebrating',
    },
    {
      id: 10,
      url: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80',
      title: 'Birthday Party',
      category: 'Events',
      tagline: 'Another year of memories',
    },
    {
      id: 11,
      url: 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&q=80',
      title: 'Anniversary',
      category: 'Events',
      tagline: 'Years of love and togetherness',
    },
    {
      id: 12,
      url: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80',
      title: 'Gala Night',
      category: 'Events',
      tagline: 'Elegance under the stars',
    },
  ],
  commercial: [
    {
      id: 13,
      url: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80',
      title: 'Product Photography',
      category: 'Commercial',
      tagline: 'Showcasing excellence in every shot',
    },
    {
      id: 14,
      url: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=800&q=80',
      title: 'Brand Shoot',
      category: 'Commercial',
      tagline: 'Your brand, our vision',
    },
    {
      id: 15,
      url: 'https://images.pexels.com/photos/38578971/pexels-photo-38578971.jpeg',
      title: 'Bright Bride',
      category: 'Wedding Bride',
      tagline: 'Shining Bride',
    },
    {
      id: 16,
      url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
      title: 'Corporate Branding',
      category: 'Commercial',
      tagline: 'Building powerful brand identity',
    },
    {
      id: 17,
      url: 'https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=800&q=80',
      title: 'Office Space',
      category: 'Commercial',
      tagline: 'Where creativity meets professionalism',
    },
  ],
  fashion: [
    {
      id: 19,
      url: 'https://images.pexels.com/photos/35738763/pexels-photo-35738763.jpeg',
      title: 'Editorial Fashion',
      category: 'Fashion',
      tagline: 'Style that speaks volumes',
    },
    {
      id: 20,
      url: 'https://images.pexels.com/photos/35738758/pexels-photo-35738758.jpeg',
      title: 'Model Portfolio',
      category: 'Fashion',
      tagline: 'Capturing confidence and grace',
    },
    {
      id: 21,
      url: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&q=80',
      title: 'Lifestyle Fashion',
      category: 'Fashion',
      tagline: 'Fashion meets everyday life',
    },
    {
      id: 22,
      url: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800&q=80',
      title: 'Street Style',
      category: 'Fashion',
      tagline: 'Urban fashion at its finest',
    },
    {
      id: 23,
      url: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=800&q=80',
      title: 'Haute Couture',
      category: 'Fashion',
      tagline: 'Elegance redefined',
    },
    {
      id: 24,
      url: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&q=80',
      title: 'Fashion Campaign',
      category: 'Fashion',
      tagline: 'Making trends come alive',
    },
  ],
  street: [
    {
      id: 25,
      url: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?w=800&q=80',
      title: 'Urban Life',
      category: 'Street',
      tagline: 'Stories from the streets',
    },
    {
      id: 26,
      url: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=800&q=80',
      title: 'City Nights',
      category: 'Street',
      tagline: 'When the city comes alive',
    },
    {
      id: 27,
      url: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&q=80',
      title: 'Street Art',
      category: 'Street',
      tagline: 'Colors of urban expression',
    },
    {
      id: 28,
      url: 'https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=800&q=80',
      title: 'Daily Moments',
      category: 'Street',
      tagline: 'Life unfiltered',
    },
    {
      id: 29,
      url: 'https://images.unsplash.com/photo-1502635385003-ee1e6a1a742d?w=800&q=80',
      title: 'Urban Architecture',
      category: 'Street',
      tagline: 'Concrete jungles with character',
    },
    {
      id: 30,
      url: 'https://images.unsplash.com/photo-1486299267070-83823f5448dd?w=800&q=80',
      title: 'Street Culture',
      category: 'Street',
      tagline: 'Authentic moments in motion',
    },
  ],
  traveling: [
    {
      id: 31,
      url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80',
      title: 'Mountain Landscape',
      category: 'Traveling',
      tagline: 'Where earth touches the sky',
    },
    {
      id: 32,
      url: 'https://images.pexels.com/photos/38578967/pexels-photo-38578967.jpeg',
      title: 'Coastal Views',
      category: 'Traveling',
      tagline: 'Serenity by the sea',
    },
    {
      id: 33,
      url: 'https://images.pexels.com/photos/18931615/pexels-photo-18931615.jpeg',
      title: 'Cultural Journey',
      category: 'Traveling',
      tagline: 'Discovering heritage and traditions',
    },
    {
      id: 34,
      url: 'https://images.pexels.com/photos/18931586/pexels-photo-18931586.jpeg',
      title: 'Adventure Travel',
      category: 'Traveling',
      tagline: 'Wanderlust in every frame',
    },
    {
      id: 35,
      url: 'https://www.pexels.com/download/video/11571314/',
      title: 'Scenic Beauty',
      category: 'Traveling',
      tagline: 'Nature at its most breathtaking',
    },
    {
      id: 36,
      url: 'https://images.pexels.com/photos/17002647/pexels-photo-17002647.jpeg',
      title: 'Sunset Travel',
      category: 'Traveling',
      tagline: 'Golden moments on the road',
    },
  ],
  birthday: [
    {
      id: 37,
      url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80',
      title: 'Mountain Landscape',
      category: 'Birthday',
      tagline: 'Celebrating life adventures',
    },
    {
      id: 38,
      url: 'https://images.pexels.com/photos/18931650/pexels-photo-18931650.jpeg',
      title: 'Coastal Views',
      category: 'Birthday',
      tagline: 'Birthday by the beach',
    },
    {
      id: 39,
      url: 'https://images.pexels.com/photos/18931615/pexels-photo-18931615.jpeg',
      title: 'Cultural Journey',
      category: 'Birthday',
      tagline: 'Memories to treasure forever',
    },
    {
      id: 40,
      url: 'https://images.pexels.com/photos/18931586/pexels-photo-18931586.jpeg',
      title: 'Adventure Travel',
      category: 'Birthday',
      tagline: 'Another year, another adventure',
    },
    {
      id: 41,
      url: 'https://www.pexels.com/download/video/11571314/',
      title: 'Scenic Beauty',
      category: 'Birthday',
      tagline: 'Life is beautiful',
    },
    {
      id: 42,
      url: 'https://images.pexels.com/photos/17002647/pexels-photo-17002647.jpeg',
      title: 'Sunset Travel',
      category: 'Birthday',
      tagline: 'Growing older, living bolder',
    },
  ],
  prewedding: [
    {
      id: 43,
      url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80',
      title: 'Mountain Landscape',
      category: 'Prewedding',
      tagline: 'Love before the vows',
    },
    {
      id: 44,
      url: 'https://images.pexels.com/photos/18931650/pexels-photo-18931650.jpeg',
      title: 'Coastal Views',
      category: 'Prewedding',
      tagline: 'Romance by the shore',
    },
    {
      id: 45,
      url: 'https://images.pexels.com/photos/18931615/pexels-photo-18931615.jpeg',
      title: 'Cultural Journey',
      category: 'Prewedding',
      tagline: 'Our story begins',
    },
    {
      id: 46,
      url: 'https://images.pexels.com/photos/18931586/pexels-photo-18931586.jpeg',
      title: 'Adventure Travel',
      category: 'Prewedding',
      tagline: 'Together forever starts now',
    },
    {
      id: 47,
      url: 'https://www.pexels.com/download/video/11571314/',
      title: 'Scenic Beauty',
      category: 'Prewedding',
      tagline: 'Love in full bloom',
    },
    {
      id: 48,
      url: 'https://images.pexels.com/photos/17002647/pexels-photo-17002647.jpeg',
      title: 'Sunset Travel',
      category: 'Prewedding',
      tagline: 'Two hearts, one journey',
    },
  ],
  matrimony: [
    {
      id: 49,
      url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80',
      title: 'Mountain Landscape',
      category: 'Matrimony',
      tagline: 'Sacred moments of union',
    },
    {
      id: 50,
      url: 'https://images.pexels.com/photos/18931650/pexels-photo-18931650.jpeg',
      title: 'Coastal Views',
      category: 'Matrimony',
      tagline: 'Eternal promises by the sea',
    },
    {
      id: 51,
      url: 'https://images.pexels.com/photos/18931615/pexels-photo-18931615.jpeg',
      title: 'Cultural Journey',
      category: 'Matrimony',
      tagline: 'Traditions that bind',
    },
    {
      id: 52,
      url: 'https://images.pexels.com/photos/18931586/pexels-photo-18931586.jpeg',
      title: 'Adventure Travel',
      category: 'Matrimony',
      tagline: 'Beginning a lifetime together',
    },
    {
      id: 53,
      url: 'https://www.pexels.com/download/video/11571314/',
      title: 'Scenic Beauty',
      category: 'Matrimony',
      tagline: 'Love everlasting',
    },
    {
      id: 54,
      url: 'https://images.pexels.com/photos/17002647/pexels-photo-17002647.jpeg',
      title: 'Sunset Travel',
      category: 'Matrimony',
      tagline: 'Forever starts today',
    },
  ],
};

export const videoGallery = [
  {
    id: 1,
    youtubeId: 'hkcovYolp3o&t=4s',
    title: 'Saurabh & Savita - Wedding Highlights',
    description: 'A beautiful garden wedding captured in stunning 4K quality',
    thumbnail: 'https://i.ytimg.com/vi/hkcovYolp3o/maxresdefault.jpg',
  },
  {
    id: 2,
    youtubeId: '19IFGK6Z46w',
    title: 'Ankit & Sonam - Wedding Highlights',
    description:
      'Professional coverage of Tech Summit featuring keynote speakers',
    thumbnail:
      'https://i.ytimg.com/vi/19IFGK6Z46w/hqdefault.jpg?sqp=-oaymwFBCNACELwBSFryq4qpAzMIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB8AEB-AH-CYAC0AWKAgwIABABGGUgSyhNMA8=&amp;rs=AOn4CLCSEC69Is5mSF4Xurh2abVMe2ieqA',
  },
  {
    id: 3,
    youtubeId: 'iQHPBY_uhMQ',
    title:
      'Wedding Teaser 2025 | Indian Wedding Coming Soon | Cinematic Love Story',
    description: 'Behind the scenes of an exclusive fashion show photoshoot',
    thumbnail:
      'https://i.ytimg.com/vi/iQHPBY_uhMQ/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&amp;rs=AOn4CLCww6KfAyP3M7TcQSigTdplHqxFnw',
  },
  {
    id: 4,
    youtubeId: 'k0hdXdAFNPw',
    title:
      'This Wedding Will Melt Your Heart | Cinematic Wedding Highlight | 4K | 2025 | Sahiba Song',
    description: 'Ravendra & Pranjal took oath to be together forever',
    thumbnail: 'https://i.ytimg.com/vi/k0hdXdAFNPw/maxresdefault.jpg',
  },
  {
    id: 5,
    youtubeId: 'UtFp1iRRcL4',
    title: 'PRAGGYA + UTKARSH | COMING SOON | WEDDING | 2025 | LUCKNOW',
    description: 'Written in love, sealed with forever.',
    thumbnail: 'https://i.ytimg.com/vi/UtFp1iRRcL4/maxresdefault.jpg',
  },
  {
    id: 6,
    youtubeId: 'A7uFpR4UpAQ',
    title: 'Wedding Highlights | Karan & Shruti | Nov 27, 2022',
    description:
      'Written in love, sealedWhere love found its forever. with forever.',
    thumbnail: 'https://i.ytimg.com/vi/A7uFpR4UpAQ/maxresdefault.jpg',
  },
  {
    id: 7,
    youtubeId: 'Ocnh0B3mt_k',
    title:
      'Cinematic Indian Wedding Film | Prayagraj | Madhavan Palace | Sushit & Aparajita | 2026',
    description:
      'Written in love, sealedWhere love found its forever. with forever.',
    thumbnail: 'https://i.ytimg.com/vi/Ocnh0B3mt_k/maxresdefault.jpg',
  },
  {
    id: 8,
    youtubeId: 'Ocnh0B3mt_k',
    title:
      'Gaurav & Pritha Engagement Highlights 2026 | Cinematic Engagement Film Lucknow',
    description:
      'Written in love, sealedWhere love found its forever. with forever.',
    thumbnail: 'https://i.ytimg.com/vi/LnuGpvFyDTY/hq720.jpg',
  },
  {
    id: 9,
    youtubeId: '_QeYA80127s',
    title: 'Lucknow Pre Wedding Film | Sushit & Aparajita',
    description:
      'Written in love, sealedWhere love found its forever. with forever.',
    thumbnail: 'https://i.ytimg.com/vi/_QeYA80127s/maxresdefault.jpg',
  },
  {
    id: 10,
    youtubeId: 'LYL_gEBQY-w',
    title: 'Sushit & Aparajita | Wedding Coming Soon',
    description:
      'Written in love, sealedWhere love found its forever. with forever.',
    thumbnail: 'https://i.ytimg.com/vi/LYL_gEBQY-w/maxresdefault.jpg',
  },
];

export const bestWorkProjects = [
  {
    id: 1,
    coupleName: 'Saurabh & Savita',
    event: 'Wedding Celebration',
    date: 'December 2024',
    coverImage:
      'https://images.pexels.com/photos/35501139/pexels-photo-35501139.jpeg',
    description: 'An intimate wedding celebration',
    gallery: [
      'https://images.pexels.com/photos/35501145/pexels-photo-35501145.jpeg',
      'https://images.pexels.com/photos/35501144/pexels-photo-35501144.jpeg',
      'https://images.pexels.com/photos/35501143/pexels-photo-35501143.jpeg',
      'https://images.pexels.com/photos/35501142/pexels-photo-35501142.jpeg',
      'https://images.pexels.com/photos/35501141/pexels-photo-35501141.jpeg',
      'https://images.pexels.com/photos/35501140/pexels-photo-35501140.jpeg',
      'https://images.pexels.com/photos/35501139/pexels-photo-35501139.jpeg',
      'https://images.pexels.com/photos/35501137/pexels-photo-35501137.jpeg',
      'https://images.pexels.com/photos/35501138/pexels-photo-35501138.jpeg',
      'https://images.pexels.com/photos/35501135/pexels-photo-35501135.jpeg',
      'https://images.pexels.com/photos/35501134/pexels-photo-35501134.jpeg',
    ],
  },
  {
    id: 2,
    coupleName: 'Deepa & Sajal',
    event: 'Wedding Celebration',
    date: 'November 2021',
    coverImage:
      'https://images.pexels.com/photos/35697996/pexels-photo-35697996.jpeg',
    description: 'An intimate wedding celebration',
    gallery: [
      'https://images.pexels.com/photos/35697995/pexels-photo-35697995.jpeg',
      'https://images.pexels.com/photos/35697994/pexels-photo-35697994.jpeg',
      'https://images.pexels.com/photos/35697993/pexels-photo-35697993.jpeg',
      'https://images.pexels.com/photos/35697992/pexels-photo-35697992.jpeg',
      'https://images.pexels.com/photos/35697991/pexels-photo-35697991.jpeg',
      'https://images.pexels.com/photos/35697989/pexels-photo-35697989.jpeg',
      'https://images.pexels.com/photos/35697987/pexels-photo-35697987.jpeg',
      'https://images.pexels.com/photos/35697986/pexels-photo-35697986.jpeg',
    ],
  },
  {
    id: 3,
    coupleName: 'Vartika & Akshay',
    event: 'Traditional Wedding',
    date: 'December 2022',
    coverImage:
      'https://images.pexels.com/photos/35474710/pexels-photo-35474710.jpeg',
    description: 'A beautiful traditional ceremony',
    gallery: [
      'https://images.pexels.com/photos/35476000/pexels-photo-35476000.jpeg',
      'https://images.pexels.com/photos/35475998/pexels-photo-35475998.jpeg',
      'https://images.pexels.com/photos/35475976/pexels-photo-35475976.jpeg',
      'https://images.pexels.com/photos/35475989/pexels-photo-35475989.jpeg',
      'https://images.pexels.com/photos/35475961/pexels-photo-35475961.jpeg',
      'https://images.pexels.com/photos/35475951/pexels-photo-35475951.jpeg',
      'https://images.pexels.com/photos/35475949/pexels-photo-35475949.jpeg',
      'https://images.pexels.com/photos/35475952/pexels-photo-35475952.jpeg',
    ],
  },
  {
    id: 4,
    coupleName: 'Karan & Shruti',
    event: 'Traditional Wedding',
    date: 'February 2025',
    coverImage:
      'https://images.pexels.com/photos/35474670/pexels-photo-35474670.jpeg',
    description: 'A dreamy Wedding in Lucknow',
    gallery: [
      'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800&q=80',
      'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800&q=80',
      'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
      'https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=800&q=80',
      'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=800&q=80',
      'https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=800&q=80',
    ],
  },
  {
    id: 5,
    coupleName: 'Rahul & Divyanshi',
    event: 'Wedding Event',
    date: 'November 2025',
    coverImage:
      'https://images.pexels.com/photos/31928931/pexels-photo-31928931.jpeg',
    description: 'A Wedding to remember',
    gallery: [
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80',
      'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
      'https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=800&q=80',
      'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80',
      'https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&q=80',
      'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80',
    ],
  },
  {
    id: 6,
    coupleName: 'Amreen & Sohrab',
    event: 'Traditional Wedding',
    date: 'February 2025',
    coverImage:
      'https://images.pexels.com/photos/35719239/pexels-photo-35719239.jpeg',
    description: 'A dreamy Wedding in Lucknow',
    gallery: [
      'https://images.pexels.com/photos/35719238/pexels-photo-35719238.jpeg',
      'https://images.pexels.com/photos/35719236/pexels-photo-35719236.jpeg',
      'https://images.pexels.com/photos/35719245/pexels-photo-35719245.jpeg',
      'https://images.pexels.com/photos/35719243/pexels-photo-35719243.jpeg',
      'https://images.pexels.com/photos/35719242/pexels-photo-35719242.jpeg',
      'https://images.pexels.com/photos/35719241/pexels-photo-35719241.jpeg',
      'https://images.pexels.com/photos/35719240/pexels-photo-35719240.jpeg',
      'https://images.pexels.com/photos/35719239/pexels-photo-35719239.jpeg',
      'https://images.pexels.com/photos/35719233/pexels-photo-35719233.jpeg',
      'https://images.pexels.com/photos/35719235/pexels-photo-35719235.jpeg',
      'https://images.pexels.com/photos/35719245/pexels-photo-35719245.jpeg',
      'https://images.pexels.com/photos/35719230/pexels-photo-35719230.jpeg',
      'https://images.pexels.com/photos/35719229/pexels-photo-35719229.jpeg',
      'https://images.pexels.com/photos/35719231/pexels-photo-35719231.jpeg',
      'https://images.pexels.com/photos/35475089/pexels-photo-35475089.jpeg',
    ],
  },
  {
    id: 7,
    coupleName: 'Ankit & Sonam',
    event: 'Traditional Wedding',
    date: 'February 2025',
    coverImage:
      'https://images.pexels.com/photos/35474718/pexels-photo-35474718.jpeg',
    description: 'A Divine Wedding in Varanasi',
    gallery: [
      'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800&q=80',
      'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800&q=80',
      'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
      'https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=800&q=80',
      'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=800&q=80',
      'https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=800&q=80',
    ],
  },
  {
    id: 8,
    coupleName: 'PRAGGYA & UTKARSH',
    event: 'Traditional Wedding',
    date: 'February 2025',
    coverImage:
      'https://images.pexels.com/photos/35500956/pexels-photo-35500956.jpeg',
    description: 'A dreamy Wedding in Lucknow',
    gallery: [
      'https://images.pexels.com/photos/35500960/pexels-photo-35500960.jpeg',
      'https://images.pexels.com/photos/35500959/pexels-photo-35500959.jpeg',
      'https://images.pexels.com/photos/35500958/pexels-photo-35500958.jpeg',
      'https://images.pexels.com/photos/35500957/pexels-photo-35500957.jpeg',
      'https://images.pexels.com/photos/35500954/pexels-photo-35500954.jpeg',
      'https://images.pexels.com/photos/35500955/pexels-photo-35500955.jpeg',
      'https://images.pexels.com/photos/35500953/pexels-photo-35500953.jpeg',
      'https://images.pexels.com/photos/35500952/pexels-photo-35500952.jpeg',
      'https://images.pexels.com/photos/35500950/pexels-photo-35500950.jpeg',
      'https://images.pexels.com/photos/35500949/pexels-photo-35500949.jpeg',
      'https://images.pexels.com/photos/35500950/pexels-photo-35500950.jpeg',
      'https://images.pexels.com/photos/35500948/pexels-photo-35500948.jpeg',
      'https://images.pexels.com/photos/35500946/pexels-photo-35500946.jpeg',
      'https://images.pexels.com/photos/35500947/pexels-photo-35500947.jpeg',
      'https://images.pexels.com/photos/31928931/pexels-photo-31928931.jpeg',
    ],
  },
  {
    id: 9,
    coupleName: 'Pre Wedding',
    event: 'Dreamy Pre-Wedding',
    date: 'February 2025',
    coverImage:
      'https://images.pexels.com/photos/36683120/pexels-photo-36683120.jpeg',
    description: 'A Dreamy Pre-Wedding in Lucknow',
    gallery: [
      'https://images.pexels.com/photos/35476219/pexels-photo-35476219.jpeg',
      'https://images.pexels.com/photos/35476218/pexels-photo-35476218.jpeg',
      'https://images.pexels.com/photos/35476217/pexels-photo-35476217.jpeg',
      'https://images.pexels.com/photos/35476216/pexels-photo-35476216.jpeg',
      'https://images.pexels.com/photos/35476215/pexels-photo-35476215.jpeg',
      'https://images.pexels.com/photos/35476215/pexels-photo-35476215.jpeg',
      'https://images.pexels.com/photos/35476214/pexels-photo-35476214.jpeg',
      'https://images.pexels.com/photos/35476210/pexels-photo-35476210.jpeg',
      'https://images.pexels.com/photos/35476206/pexels-photo-35476206.jpeg',
      'https://images.pexels.com/photos/35476211/pexels-photo-35476211.jpeg',
    ],
  },
  {
    id: 10,
    coupleName: 'Kajal & Shrey',
    event: 'Dreamy Wedding',
    date: 'February 2026',
    coverImage:
      'https://images.pexels.com/photos/38578964/pexels-photo-38578964.jpeg',
    description: 'A Dreamy Wedding in Lucknow',
    gallery: [
      'https://images.pexels.com/photos/35476219/pexels-photo-35476219.jpeg',
      'https://images.pexels.com/photos/35476218/pexels-photo-35476218.jpeg',
      'https://images.pexels.com/photos/35476217/pexels-photo-35476217.jpeg',
      'https://images.pexels.com/photos/35476216/pexels-photo-35476216.jpeg',
      'https://images.pexels.com/photos/35476215/pexels-photo-35476215.jpeg',
      'https://images.pexels.com/photos/35476215/pexels-photo-35476215.jpeg',
      'https://images.pexels.com/photos/35476214/pexels-photo-35476214.jpeg',
      'https://images.pexels.com/photos/35476210/pexels-photo-35476210.jpeg',
      'https://images.pexels.com/photos/35476206/pexels-photo-35476206.jpeg',
      'https://images.pexels.com/photos/35476211/pexels-photo-35476211.jpeg',
    ],
  },
  {
    id: 11,
    coupleName: 'Family Portraits',
    event: 'Indoor Shots',
    date: 'January 2026',
    coverImage:
      'https://images.pexels.com/photos/36061431/pexels-photo-36061431.jpeg',
    description: 'A Family Portrait session in Lucknow',
    gallery: [
      'https://images.pexels.com/photos/36061438/pexels-photo-36061438.jpeg',
      'https://images.pexels.com/photos/36061437/pexels-photo-36061437.jpeg',
      'https://images.pexels.com/photos/36061436/pexels-photo-36061436.jpeg',
      'https://images.pexels.com/photos/36061434/pexels-photo-36061434.jpeg',
      'https://images.pexels.com/photos/36061433/pexels-photo-36061433.jpeg',
      'https://images.pexels.com/photos/36061432/pexels-photo-36061432.jpeg',
      'https://images.pexels.com/photos/36061431/pexels-photo-36061431.jpeg',
      'https://images.pexels.com/photos/36061430/pexels-photo-36061430.jpeg',
      'https://images.pexels.com/photos/36061435/pexels-photo-36061435.jpeg',
    ],
  },
  {
    id: 12,
    coupleName: 'Sweety & Priyabh',
    event: 'Emotional Wedding',
    date: 'February 2025',
    coverImage:
      'https://images.pexels.com/photos/36061431/pexels-photo-36061431.jpeg',
    description: 'A Wedding Photographysession in Lucknow',
    gallery: [
      'https://images.pexels.com/photos/36061438/pexels-photo-36061438.jpeg',
      'https://images.pexels.com/photos/36061437/pexels-photo-36061437.jpeg',
      'https://images.pexels.com/photos/36061436/pexels-photo-36061436.jpeg',
      'https://images.pexels.com/photos/36061434/pexels-photo-36061434.jpeg',
      'https://images.pexels.com/photos/36061433/pexels-photo-36061433.jpeg',
      'https://images.pexels.com/photos/36061432/pexels-photo-36061432.jpeg',
      'https://images.pexels.com/photos/36061431/pexels-photo-36061431.jpeg',
      'https://images.pexels.com/photos/36061430/pexels-photo-36061430.jpeg',
      'https://images.pexels.com/photos/36061435/pexels-photo-36061435.jpeg',
    ],
  },
  {
    id: 13,
    coupleName: 'Baby Shoot',
    event: 'Baby Photography',
    date: 'February 2025',
    coverImage:
      'https://images.pexels.com/photos/35996815/pexels-photo-35996815.jpeg',
    description: 'A Baby Photography session in Lucknow',
    gallery: [
      'https://images.pexels.com/photos/35996814/pexels-photo-35996814.jpeg',
      'https://images.pexels.com/photos/35996813/pexels-photo-35996813.jpeg',
      'https://images.pexels.com/photos/35996812/pexels-photo-35996812.jpeg',
      'https://images.pexels.com/photos/35996811/pexels-photo-35996811.jpeg',
      'https://images.pexels.com/photos/35996810/pexels-photo-35996810.jpeg',
      'https://images.pexels.com/photos/35996809/pexels-photo-35996809.jpeg',
      'https://images.pexels.com/photos/35996808/pexels-photo-35996808.jpeg',
      'https://images.pexels.com/photos/35996807/pexels-photo-35996807.jpeg',
    ],
  },
  {
    id: 14,
    coupleName: 'Shubham & Mahi',
    event: 'Wedding Photography',
    date: 'February 2026',
    coverImage:
      'https://images.pexels.com/photos/36308142/pexels-photo-36308142.jpeg',
    description: 'A Wedding Photography session in Lucknow',
    gallery: [
      'https://images.pexels.com/photos/35996814/pexels-photo-35996814.jpeg',
      'https://images.pexels.com/photos/35996813/pexels-photo-35996813.jpeg',
      'https://images.pexels.com/photos/35996812/pexels-photo-35996812.jpeg',
      'https://images.pexels.com/photos/35996811/pexels-photo-35996811.jpeg',
      'https://images.pexels.com/photos/35996810/pexels-photo-35996810.jpeg',
      'https://images.pexels.com/photos/35996809/pexels-photo-35996809.jpeg',
      'https://images.pexels.com/photos/35996808/pexels-photo-35996808.jpeg',
      'https://images.pexels.com/photos/35996807/pexels-photo-35996807.jpeg',
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Vartika Singh',
    role: 'Bride',
    content:
      'Frames by Gaurav captured our wedding day perfectly. Every moment, every emotion was beautifully preserved. The team was professional, creative, and made us feel so comfortable.',
    rating: 5,
    image: '/images/vartika.jpg',
    screenshot: '/images/vartikaReview.jpg',
  },
  {
    id: 2,
    name: 'Praggya Mehra',
    role: 'Groom',
    content:
      'Exceptional photography service! They understood our vision and delivered beyond expectations. The attention to detail and artistic approach made our wedding album truly special.',
    rating: 5,
    image:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&q=80',
    screenshot:
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=600&q=80',
  },
  {
    id: 3,
    name: 'Akshay Gautam',
    role: 'Event Manager',
    content:
      'We have worked with Frames by Gaurav on multiple corporate events. Their professionalism and ability to capture key moments is unmatched. Highly recommended!',
    rating: 5,
    image:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&q=80',
    screenshot:
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=600&q=80',
  },
  {
    id: 4,
    name: 'Urvashi',
    role: 'Bride',
    content:
      'The fashion shoot with Frames by Gaurav was incredible. They have an eye for style and composition that brings out the best in every design. Truly talented team!',
    rating: 5,
    image:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80',
    screenshot:
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=600&q=80',
  },
  {
    id: 5,
    name: 'Rahul',
    role: 'Groom',
    content:
      'Professional, creative, and reliable. Frames by Gaurav has been our go-to photography partner for all our commercial shoots. The quality is consistently outstanding.',
    rating: 5,
    image:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80',
    screenshot:
      'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&q=80',
  },
  {
    id: 6,
    name: 'Saurabh',
    role: 'Groom',
    content:
      'Our engagement and wedding photos are absolutely stunning. The team made us feel relaxed and captured the most beautiful candid moments. We will treasure these forever!',
    rating: 5,
    image:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&q=80',
    screenshot:
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=600&q=80',
  },
];

export const experienceData = {
  yearsOfExperience: '12+',
  projectsCompleted: 500,
  happyClients: 450,
  awards: 15,
  journey: [
    {
      year: '2012',
      title: 'The Beginning',
      description:
        'Started Frames by Gaurav with a passion for capturing authentic moments and telling stories through photography.',
    },
    {
      year: '2015',
      title: 'Studio Expansion',
      description:
        'Opened our first professional studio and expanded into commercial and fashion photography.',
    },
    {
      year: '2018',
      title: 'National Recognition',
      description:
        'Received multiple awards and started working with international clients and brands.',
    },
    {
      year: '2021',
      title: 'Team Growth',
      description:
        'Built a talented team of photographers and videographers to serve diverse photography needs.',
    },
    {
      year: '2025',
      title: 'Today',
      description:
        'Continuing to capture beautiful moments and create timeless memories for clients worldwide.',
    },
  ],
  expertise: [
    { name: 'Wedding Photography', level: 100 },
    { name: 'Event Coverage', level: 92 },
    { name: 'Commercial Shoots', level: 90 },
    { name: 'Fashion Photography', level: 88 },
    { name: 'Street Photography', level: 85 },
    { name: 'Travel Photography', level: 87 },
  ],
};

export const aboutData = {
  title: 'Frames by Gaurav',
  tagline: 'Capturing Moments, Creating Memories',
  story:
    "Frames by Gaurav was born from a simple belief: every moment tells a story, and every story deserves to be beautifully preserved. For over a decade, we've been dedicated to capturing the essence of life's most precious moments through our lens.\n\nOur approach combines artistic vision with technical excellence. We don't just take photographs; we create visual narratives that evoke emotions and stand the test of time. Whether it's the intimate moments of a wedding, the energy of a corporate event, or the elegance of a fashion shoot, we bring the same level of passion and professionalism to every project.\n\nWhat sets us apart is our commitment to understanding your vision and translating it into stunning imagery. We believe in building connections with our clients, ensuring that every photograph reflects not just what we see, but what you feel.\n\nFrom weddings to commercial projects, from street photography to destination shoots, Frames by Gaurav has grown into a trusted name in the photography industry. Our team of skilled photographers brings diverse expertise and a shared dedication to excellence.",
  mission:
    'To capture authentic moments and create timeless memories through exceptional photography that tells your unique story.',
  values: [
    {
      title: 'Authenticity',
      description:
        'We capture genuine moments and real emotions, creating photographs that truly represent your story.',
    },
    {
      title: 'Excellence',
      description:
        'We maintain the highest standards in every aspect of our work, from equipment to post-production.',
    },
    {
      title: 'Creativity',
      description:
        'We bring fresh perspectives and artistic vision to every project, ensuring unique and memorable results.',
    },
    {
      title: 'Integrity',
      description:
        'We build trust through honest communication, reliable service, and consistent quality.',
    },
  ],
};

export const teamData = [
  {
    id: 1,
    name: 'Gaurav Vishwakarma',
    role: 'Cinematographer',
    image:
      'https://images.pexels.com/photos/35474949/pexels-photo-35474949.jpeg',
    bio: 'With over 8 years of experience in photography, Gaurav founded Frames by Gaurav with a vision to capture authentic emotions and create timeless memories. His passion for storytelling through the lens has made him one of the most sought-after photographers in the industry.',
    instagram: 'https://www.instagram.com/_btsandbeyond_',
  },
];

// Portrait Shoot Gallery
export const portraitGallery = [
  {
    id: 1,
    url: 'https://images.pexels.com/photos/35838617/pexels-photo-35838617.jpeg',
    title: 'Classic Portrait',
    category: 'Portrait',
    tagline: 'Capturing timeless elegance',
  },
  {
    id: 2,
    url: 'https://images.pexels.com/photos/35838616/pexels-photo-35838616.jpeg',
    title: 'Studio Session',
    category: 'Portrait',
    tagline: 'Professional headshots done right',
  },
  {
    id: 3,
    url: 'https://images.pexels.com/photos/35838615/pexels-photo-35838615.jpeg',
    title: 'Natural Light',
    category: 'Portrait',
    tagline: 'Beauty in simplicity',
  },
  {
    id: 4,
    url: 'https://images.pexels.com/photos/35838614/pexels-photo-35838614.jpeg',
    title: 'Urban Portrait',
    category: 'Portrait',
    tagline: 'City lights and personal heights',
  },
  {
    id: 5,
    url: 'https://images.pexels.com/photos/35838612/pexels-photo-35838612.jpeg',
    title: 'Outdoor Session',
    category: 'Portrait',
    tagline: 'Nature as the perfect backdrop',
  },
  {
    id: 6,
    url: 'https://images.pexels.com/photos/35838613/pexels-photo-35838613.jpeg',
    title: 'Creative Angle',
    category: 'Portrait',
    tagline: 'Perspective changes everything',
  },
  {
    id: 7,
    url: 'https://images.pexels.com/photos/35838610/pexels-photo-35838610.jpeg',
    title: 'Candid Moment',
    category: 'Portrait',
    tagline: 'Genuine smiles captured',
  },
  {
    id: 8,
    url: 'https://images.pexels.com/photos/35838609/pexels-photo-35838609.jpeg',
    title: 'Fashion Forward',
    category: 'Portrait',
    tagline: 'Style meets personality',
  },
  {
    id: 9,
    url: 'https://images.pexels.com/photos/35838611/pexels-photo-35838611.jpeg',
    title: 'Artistic Vision',
    category: 'Portrait',
    tagline: 'Every face tells a story',
  },
  {
    id: 10,
    url: 'https://images.pexels.com/photos/35838607/pexels-photo-35838607.jpeg',
    title: 'Professional Edge',
    category: 'Portrait',
    tagline: 'Corporate excellence captured',
  },
  {
    id: 11,
    url: 'https://images.pexels.com/photos/35838606/pexels-photo-35838606.jpeg',
    title: 'Lifestyle Portrait',
    category: 'Portrait',
    tagline: 'Living your best life',
  },
  {
    id: 12,
    url: 'https://images.pexels.com/photos/35838608/pexels-photo-35838608.jpeg',
    title: 'Modern Classic',
    category: 'Portrait',
    tagline: 'Contemporary meets timeless',
  },
  {
    id: 13,
    url: 'https://images.pexels.com/photos/35838605/pexels-photo-35838605.jpeg',
    title: 'Authentic Expression',
    category: 'Portrait',
    tagline: 'True to yourself',
  },
  {
    id: 14,
    url: 'https://images.pexels.com/photos/35838604/pexels-photo-35838604.jpeg  ',
    title: 'Elegant Pose',
    category: 'Portrait',
    tagline: 'Grace in every frame',
  },
];

// Creative Photoshoot Gallery
export const creativeGallery = [
  {
    id: 1,
    url: 'https://images.pexels.com/photos/35738761/pexels-photo-35738761.jpeg',
    title: 'Abstract Vision',
    category: 'Creative',
    tagline: 'Where imagination meets reality',
  },
  {
    id: 2,
    url: 'https://images.pexels.com/photos/35738758/pexels-photo-35738758.jpeg',
    title: 'Artistic Expression',
    category: 'Creative',
    tagline: 'Breaking the boundaries of convention',
  },
  {
    id: 3,
    url: 'https://images.pexels.com/photos/35697246/pexels-photo-35697246.jpeg',
    title: 'Color Symphony',
    category: 'Creative',
    tagline: 'Painting stories with light',
  },
  {
    id: 4,
    url: 'https://images.pexels.com/photos/35697247/pexels-photo-35697247.jpeg',
    title: 'Conceptual Art',
    category: 'Creative',
    tagline: 'Ideas brought to life',
  },
  {
    id: 5,
    url: 'https://images.pexels.com/photos/35697245/pexels-photo-35697245.jpeg',
    title: 'Surreal Moments',
    category: 'Creative',
    tagline: 'Beyond the ordinary',
  },
  {
    id: 6,
    url: 'https://images.pexels.com/photos/1040945/pexels-photo-1040945.jpeg',
    title: 'Dramatic Lighting',
    category: 'Creative',
    tagline: 'Shadows and highlights dance',
  },
  {
    id: 7,
    url: 'https://images.pexels.com/photos/35694214/pexels-photo-35694214.jpeg',
    title: 'Innovative Perspective',
    category: 'Creative',
    tagline: 'Seeing the world differently',
  },
  {
    id: 8,
    url: 'https://images.pexels.com/photos/35638325/pexels-photo-35638325.jpeg',
    title: 'Bold Statement',
    category: 'Creative',
    tagline: 'Fearless and unforgettable',
  },
  {
    id: 9,
    url: 'https://images.pexels.com/photos/35638320/pexels-photo-35638320.jpeg',
    title: 'Experimental Art',
    category: 'Creative',
    tagline: 'Pushing creative boundaries',
  },
  {
    id: 10,
    url: 'https://images.pexels.com/photos/1858144/pexels-photo-1858144.jpeg',
    title: 'Visual Poetry',
    category: 'Creative',
    tagline: 'Words without speaking',
  },
  {
    id: 11,
    url: 'https://images.pexels.com/photos/18931667/pexels-photo-18931667.jpeg',
    title: 'Modern Edge',
    category: 'Creative',
    tagline: 'Contemporary and cutting-edge',
  },
  {
    id: 12,
    url: 'https://images.pexels.com/photos/1898555/pexels-photo-1898555.jpeg',
    title: 'Unique Composition',
    category: 'Creative',
    tagline: 'One of a kind artistry',
  },
];

export const storeProducts = [
  {
    id: 'luts-premiere',
    name: 'LUTs for Premiere Pro',
    price_inr: 999,
    currency: 'INR',
    description:
      'Cinematic color grading pack crafted for wedding films, portraits, and golden-hour edits.',
    includes: ['120+ LUTs', 'Cinematic & moody looks', 'Step-by-step guide'],
    heroImage:
      'https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=1400&q=80',
    beforeAfter: [
      {
        label: 'Warm wedding tones',
        before:
          'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
        after:
          'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800&q=80',
      },
      {
        label: 'Moody reception look',
        before:
          'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=800&q=80',
        after:
          'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=800&q=80',
      },
    ],
    sampleVideos: [
      {
        title: 'Premiere Pro LUTs Preview',
        src: 'https://www.youtube.com/watch?v=K4TOrB7at0Y',
      },
    ],
    tutorialVideos: [
      {
        title: 'How to apply LUTs in Premiere Pro',
        src: 'https://www.youtube.com/watch?v=H1vEN3vJ5oY',
      },
    ],
  },
  {
    id: 'luts-photoshop',
    name: 'LUTs for Photoshop',
    price_inr: 999,
    currency: 'INR',
    description:
      'Fine-tuned LUTs for editorial portraits, bridal sessions, and clean studio lighting.',
    includes: ['90+ LUTs', 'Skin tone safe', 'Before/after presets'],
    heroImage:
      'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1400&q=80',
    beforeAfter: [
      {
        label: 'Soft portrait finish',
        before:
          'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800&q=80',
        after:
          'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&q=80',
      },
      {
        label: 'Studio editorial tone',
        before:
          'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=800&q=80',
        after:
          'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800&q=80',
      },
    ],
    sampleVideos: [
      {
        title: 'Photoshop LUTs Preview',
        src: 'https://www.youtube.com/watch?v=2mV9R1uYtZk',
      },
    ],
    tutorialVideos: [
      {
        title: 'How to apply LUTs in Photoshop',
        src: 'https://www.youtube.com/watch?v=R4g_9dP5c3Y',
      },
    ],
  },
  {
    id: 'luts-lightroom',
    name: 'LUTs for Adobe Lightroom',
    price_inr: 1299,
    currency: 'INR',
    description:
      'Lightroom-ready LUTs designed for soft pastel, clean whites, and bold contrast edits.',
    includes: ['140+ LUTs', 'Mobile & Desktop', 'Seasonal packs'],
    heroImage:
      'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=1400&q=80',
    beforeAfter: [
      {
        label: 'Clean daylight edit',
        before:
          'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=800&q=80',
        after:
          'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=800&q=80&sat=-20',
      },
      {
        label: 'Pastel travel vibe',
        before:
          'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=800&q=80',
        after:
          'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=800&q=80&sat=-30',
      },
    ],
    sampleVideos: [
      {
        title: 'Lightroom LUTs Preview',
        src: 'https://www.youtube.com/watch?v=G1H2-6GqWg4',
      },
    ],
    tutorialVideos: [
      {
        title: 'How to apply LUTs in Lightroom',
        src: 'https://www.youtube.com/watch?v=5guZ6p6M3Go',
      },
    ],
  },
];
